import { Fragment, type ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Пары «ярлык — значение» СТРОКАМИ: ярлык слева в узкой колонке, значение
 * справа во всю оставшуюся ширину.
 *
 * Не то же, что FactGrid. Тот — плитки в две колонки, и годится, когда пар
 * много и значения короткие: пол, возраст, родинки. Здесь пар две-три, а
 * значением бывает ссылка или целое предложение («Гость: аккаунта нет в
 * списке участников») — в плитке на пол-экрана оно ломалось по слогам.
 */
export interface Def {
  label: string;
  value: ReactNode;
}

export function DefList({ items }: { items: Def[] }) {
  const shown = items.filter((item) => item.value !== null && item.value !== '');
  if (shown.length === 0) return null;

  return (
    <dl className={styles.defList}>
      {shown.map((item) => (
        // dt и dd лежат в сетке напрямую: обёртка-строка потребовала бы
        // subgrid, а он есть не во всех вебвью, куда ВК грузит приложение.
        <Fragment key={item.label}>
          <dt className={styles.defLabel}>{item.label}</dt>
          <dd className={styles.defValue}>{item.value}</dd>
        </Fragment>
      ))}
    </dl>
  );
}
